import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

function ShopByCategory() {
  const categories = [
    {
      title: "Sunglasses",
      img: "https://image4.cdnsbg.com/2/361/637995_1697082195479.jpg?width=450&height=225",
      link: "/category?type=sunglasses",
    },
    {
      title: "Power Glasses",
      img: "https://image4.cdnsbg.com/2/248/570296_1699511458560.jpg?width=450&height=225",
      link: "/category?type=power-sunglasses",
    },
    {
      title: "Computer Glasses",
      img: "https://image4.cdnsbg.com/2/248/526493_1699328164500.jpg?width=450&height=225",
      link: "/category?type=computer-glasses",
    },
    {
      title: "Contact Lenses",
      img: "https://image4.cdnsbg.com/2/81/610141_1704718365075.jpg?width=450&height=225",
      link: "/category?type=contact-lenses",
    },
    // {
    //   title: "Blue Cut Glasses",
    //   img: "https://image4.cdnsbg.com/2/81/610141_1704718365075.jpg?width=450&height=225",
    // },
    {
      title: "Kids Glasses",
      img: "https://image4.cdnsbg.com/2/81/610141_1704718365075.jpg?width=450&height=225",
      link: "/category?type=kids-glasses",
    },
    // {
    //   title: "Reading Glasses",
    //   img: "https://image4.cdnsbg.com/2/81/610141_1704718365075.jpg?width=450&height=225",
    // },
    // {
    //   title: "Sports Glasses",
    //   img: "https://image4.cdnsbg.com/2/81/610141_1704718365075.jpg?width=450&height=225",
    // },
    // {
    //   title: "Fashion Frames",
    //   img: "https://image4.cdnsbg.com/2/81/610141_1704718365075.jpg?width=450&height=225",
    // },
  ];
  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="featured-header">
            <div className="featured-header-inner">
              <h2 className="featured-title">Featured Categories</h2>
              <p className="featured-subtitle">
                Select your Featured Categories
              </p>
            </div>
          </div>
          <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: ".shop-prev",
              nextEl: ".shop-next",
            }}
            autoplay={{ delay: 3000 }}
            spaceBetween={20}
            slidesPerView={4}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 3 },
              992: { slidesPerView: 4 },
              1200: { slidesPerView: 5 },
            }}
          >
            {categories.map((item, index) => (
              <SwiperSlide key={index}>
                <Link to={item.link}>
                  <div className="card_wrapper cursor-pointer">
                    <div className="card-media relative">
                      <img src={item.img} alt={item.title} className="" />
                    </div>
                    <div className="card-content text-center mt-3">
                      <h3 className="card-title text-lg font-medium text-black">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="shop-nav-wrapper">
            <button className="shop-prev">‹</button>
            <button className="shop-next">›</button>
          </div>
        </div>
      </section>
    </>
  );
}

export default ShopByCategory;
